module.exports = __webpack_public_path__ + "static/media/EP02@m.0e531db5.jpg";